export const COUNTRY_CODE_AU = 'AU';
export const COUNTRY_CODE_NZ = 'NZ';
